export const SOLUTION_LAUNCHPAD_CAN_VIEW = 'SOLUTION_LAUNCHPAD_CAN_VIEW';
